module.exports = __webpack_public_path__ + "static/media/greyArrow.729aa4c8.svg";